import { Fragment, useRef, useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { valueFormat } from "src/helper/valueFormat";
import { itemPromotionTitle } from "src/helper/itemPromotions";
import { 
  NamePriceRowWrapper, 
  MofiferNameWrapper,
  MofiferOptionsNameWrapper,
  MofiferOptionsTextWrapper,
  MofiferOptionsPriceText,
  MofiferOptionsText
 } from "./styles";

const styles = {
  row: {
    marginBottom: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  countCell: {
    textAlign: "left",
    fontSize: "16px",
  },
  nameCell: {
    textAlign: "left",
    padding: "0 16px 0 12px",
    fontSize: "16px",
    fontWeight: 600,
  },
  priceCell: {
    textAlign: "right",
  },
};


const OrderProduct = ({ product, promotionLines = [] }) => {

  const containerRef = useRef(null);
  const priceRef = useRef(null);
  const modPriceRef = useRef(null);
  const [nameWidth, setNameWidth] = useState("100%");
  const [modPriceWidth, setModPriceWidth] = useState("100%");

  useEffect(() => {
    if (!containerRef.current || !priceRef.current) return;

    const update = () => {
      const container = containerRef.current;
      const price = priceRef.current;
      const containerWidth = container?.offsetWidth;
      const priceWidth = price?.offsetWidth;
      const available = containerWidth - priceWidth; // include safe padding
      const modPriceWidth = modPriceRef?.current?.offsetWidth;
      setNameWidth(`${available}px`);
      setModPriceWidth(`${modPriceWidth - 32}px`);
    };

    update(); // run once initially

    const resizeObserver = new ResizeObserver(() => {
      update(); // update anytime size changes
    });

    resizeObserver.observe(containerRef.current);
    resizeObserver.observe(priceRef.current);

    return () => resizeObserver.disconnect();
  }, [containerRef?.current, priceRef?.current, modPriceRef?.current]);

  return (

    <>
      <Box sx={styles.row} ref={containerRef} >
        <NamePriceRowWrapper sx={{ maxWidth: nameWidth }}>
          <Typography sx={styles.countCell}>{`${product.quantity}x`}</Typography>

          <Typography
            className="uppercase"
            sx={{
              ...styles.nameCell,
              maxWidth: nameWidth,
            }}
          >
            {product?.name}
          </Typography>
        </NamePriceRowWrapper>

        <Box ref={priceRef}>
          <Typography
            sx={{
              width: priceRef?.current?.offsetWidth,
            }}
          >
             {valueFormat(`$${Number(product?.price || 0).toFixed(2)}`)}
          </Typography>
        </Box>
      </Box>

    {product?.modifier &&
     product?.modifier?.length > 0 &&
      product?.modifier.map((mod) => (
        <Fragment key={mod?._id}>
          <MofiferNameWrapper
            sx={{
              marginRight: `${(priceRef?.current?.offsetWidth || 0)}px !important`,
            }}
            className="modifier-main-name"
          >
            {mod?.name?.toUpperCase()}
          </MofiferNameWrapper>

          {mod &&
           mod?.list?.length > 0 &&
           mod?.list?.map((item) => (
            <MofiferOptionsNameWrapper key={item?._id}>
              <MofiferOptionsTextWrapper sx={{ maxWidth: nameWidth }}>
                <MofiferOptionsText>
                  {item?.count ? <b>{`${item?.count}x `}</b> : null}
                  <span>{item?.name}</span>
                  {item?.freeCount ? <b>{` (${item?.freeCount} free)`}</b> : null}
                </MofiferOptionsText>
              </MofiferOptionsTextWrapper>

              <MofiferOptionsPriceText ref={modPriceRef}>
                {item?.isFree
                  ? "-"
                  : valueFormat(`$${Number(item?.price).toFixed(2)}`)}
              </MofiferOptionsPriceText>
            </MofiferOptionsNameWrapper>
          ))}
        </Fragment>
      ))}
      {promotionLines.map((line) => (
        <Box key={line.key} className="item-promotion">
          <span className="item-promotion-label">
            {itemPromotionTitle(line.isCoupon ? "Coupon" : "Promotion", line.name)}
          </span>
          <span className="item-promotion-price">
            {valueFormat(`($${Number(line.amount || 0).toFixed(2)})`)}
          </span>
        </Box>
      ))}
    </>
  );
};
export default OrderProduct;
